<template>
    <el-row :gutter="30" class="mw-100">
        <el-col :lg="24" :xs="24">
           
            <el-card class="box-card">
                <el-table :data="Logos" style="width: 100%">
                    
                    
                     <el-table-column label="image" prop="imageURL" width="80">
                        <template #default="scope">
                            <el-image 
                                style="width: 50px; height: 50px" 
                                :src="$getImage(scope.row.imageURL) || ''" 
                                fit="cover"
                                :zoom-rate="1.2"
                                :preview-src-list="[$getImage(scope.row.imageURL)]"
                                :preview-teleported="true"
                            >
                                <template #error>
                                    <div class="image-slot">
                                        <font-awesome-icon :icon="['fas', 'image']" />
                                    </div>
                                </template>
                            </el-image>
                        </template>
                    </el-table-column>
                    
                    <el-table-column label="logo" prop="id"/>
                    <el-table-column label="Operations" width="100" align="right">
                        <template #default="scope">
                            <el-tooltip
                                class="box-item"
                                effect="dark"
                                content="edit logo"
                                placement="top"
                            >
                                <font-awesome-icon :icon="['fas', 'edit']" style="width:20px" @click="handleEditLogo(scope.row)" class="cursor-pointer" />
                            </el-tooltip>
                             
                                
                        </template>
                    </el-table-column>
                </el-table>
               
            </el-card>
        </el-col>
    </el-row>
</template>
<script>
export default {
    computed:{
        cachedLogos(){
            return JSON.parse(localStorage.getItem('adminStore'))?.website?.settings?.logos?.list || []
        },
    },
    data(){
        return{
            Logos:[],
            LogoStatus:[],
           
        }
    },
    async mounted(){
        if (!this.cachedLogos?.length){
            this.getAllLogos();
        }else{
            this.Logos = this.cachedLogos;
          
        }
        
       
    },
    
    methods:{
       
        async getAllLogos(){
            const response = await this.$store.dispatch('getAllLogos');

            this.Logos = response;
             
        },
        
      
        async handleEditLogo(Logo){
            await this.$store.dispatch('storeCurrentLogoToView',Logo)
            this.$router.push({
                name:'manage-logo',
                params:{
                    id:Logo.id
                }
            })
        },
      
    
       
        
    }
}
</script>
<style lang="scss">
    .text-right.rtl {
        .cell {
            text-align: right;
            direction: rtl;
        }
    }
</style>